<template>
  <b-container>
    <div>
      <h1>{{ $t("checklist.form.fillDetails") }}</h1>
      <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    </div>
    <div v-if="checklist">
      <b-row v-if="checklist.draft == false">
        <b-col v-if="showBackToList" md="none">
          <a @click="$router.go(-1)">
            <b-button size="sm">
              {{ $t("geral.backtolist") }}
            </b-button>
          </a>
        </b-col>

        <!-- BotÃ£o da empresas q possui layout prÃ³prio -->
        <b-col md="none" class="ml-2">
          <b-button
            v-if="companyId == 178 || companyId == 259"
            size="sm"
            @click="exportPdf()"
            >{{ $t("geral.exportPdf") }}
          </b-button>
          <!-- BotÃ£o para as empresas com o layout padrÃ£o -->
          <b-button v-else size="sm" @click="openModal()">
            {{ $t("geral.exportPdf") }}
          </b-button>
        </b-col>

        <b-modal
          id="modal-scrollable"
          class="kanban-modal"
          scrollable
          size="lg"
          ref="openModal"
          :title="$t('geral.exportPdf')"
        >
          <checklist-pdf-export-parameters :params.sync="parameters" />

          <template #modal-footer="{ cancel }">
            <div class="right">
              <b-button variant="green" @click="exportPdfV2()">
                {{ $t("geral.confirm") }}
              </b-button>
              <b-button class="ml-2" variant="danger" @click="cancel()">
                {{ $t("geral.cancel") }}
              </b-button>
            </div>
          </template>
        </b-modal>
        <b-col md="none" class="ml-2">
          <b-button size="sm" @click="reopenChecklistDialog()">
            {{ $t("geral.reopen") }}
          </b-button>
        </b-col>
        <!-- reabrir formulario -->
        <base-dialog-confirm
          ref="reopenConfirmDialog"
          title=""
          :message="$t('geral.reopenConfirm')"
          @confirm="reopenChecklist"
        >
        </base-dialog-confirm>
        <b-col md="none" class="ml-2">
          <b-button size="sm" @click="openMap()">
            {{ $t("geral.location") }}
          </b-button>
        </b-col>

        <b-col md="none" class="ml-2">
          <b-button size="sm" @click="openHistoryChange()">
            {{ $t("geral.history") }}
          </b-button>
          <checklist-history ref="history" :id="id"></checklist-history>
        </b-col>

        <!-- LocalizaÃ§Ã£o -->
        <checklist-filled-map
          ref="openMap"
          :latitude="checklist.latitude"
          :longitude="checklist.longitude"
        ></checklist-filled-map>

        <b-col
          v-if="checklist.formId == $store.getters.formVehicleRevisionEntryId"
          md="none"
        >
          <router-link
            :to="`/checklist/Layout/form/Fill/${$store.getters.formVehicleRevisionExitId}/${checklist.checklistId}`"
          >
            <b-button
              size="sm"
              v-b-tooltip.hover
              title="preencher saÃ­da da manutenÃ§Ã£o"
              v-if="!hasExitFillFilled"
            >
              SaÃ­da da manutenÃ§Ã£o
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          <router-link
            :to="`/checklist/Layout/form/Fill/${checklist.formId}/${checklist.checklistId}`"
          >
            <b-button
              size="sm"
              v-b-tooltip.hover
              :title="$t('checklist.form.continueFillingTooltip')"
            >
              {{ $t("checklist.form.continueFillingTooltip") }}
            </b-button>
          </router-link>
        </b-col>
      </b-row>

      <b-row class="mb-3 ml-0">
        <b-col> </b-col>
        <b-col> </b-col>
      </b-row>
      <b-row>
        <b-col lg="8" md="" sm="12">
          <b-form-group
            label="Formulario"
            label-for="input-formName"
            label-cols-sm="5"
            label-cols-md="5"
            label-cols-lg="5"
          >
            <b-form-input
              type="text"
              id="input-formName"
              v-model="checklist.formName"
              readonly
            />
          </b-form-group>
          <b-form-group
            label="Data preenchimento"
            label-for="input-dateFill"
            label-cols-sm="5"
            label-cols-md="5"
            label-cols-lg="5"
          >
            <b-form-input
              type="text"
              id="input-dateFill"
              v-model="formatedDateFill"
              readonly
            />
          </b-form-group>
          <b-form-group
            label="ResponsÃ¡vel preenchimento"
            label-for="input-userFillName"
            label-cols-sm="5"
            label-cols-md="5"
            label-cols-lg="5"
          >
            <b-form-input
              type="text"
              id="input-userFillName"
              v-model="checklist.userFillName"
              readonly
            />
          </b-form-group>
        </b-col>
      </b-row>

      <h2>{{ $t("checklist.form.values") }}</h2>

      <div class="mb-4">
        <b-button
          class="ml-2"
          v-if="!isShowingEveryAttachments && hasAttachments"
          size="sm"
          @click="showAllAttachments"
        >
          {{ $t("geral.showAllAttachments") }}
        </b-button>
        <b-button
          class="ml-2"
          v-if="isShowingEveryAttachments && hasAttachments"
          size="sm"
          @click="hideEveryAttachments"
        >
          {{ $t("geral.hideAllAttachments") }}
        </b-button>
        <b-button
          class="ml-2"
          size="sm"
          v-if="!showAllPendency && hasPendency"
          @click="viewAllPendencyFields"
        >
          <i class="mr-1 mb-1 tim-icons icon-alert-circle-exc"></i>
          {{ $t("checklist.pendencies.fieldsWithPendency") }}
        </b-button>
        <b-button
          class="ml-2"
          size="sm"
          v-if="showAllPendency && hasPendency"
          @click="closeAllPendencyFields"
        >
          {{ $t("checklist.pendencies.fieldsAll") }}
        </b-button>
      </div>
      <div v-if="showAllPendency">
        <div v-for="value in fieldsWithPendency" :key="value.id">
          <b-row>
            <!-- {{ value }} -->
            <b-col lg="8" md="8" sm="12">
              <checklist-filled-details-field
                ref="checklistFilledDetailsField"
                :checklist-value="value"
                @after-attachment-show="verifyShowingEveryAttachments"
              >
              </checklist-filled-details-field>
            </b-col>
          </b-row>
        </div>
      </div>
      <div v-else>
        <!-- {{ checklist }} -->
        <div v-for="value in checklist.values" :key="value.id">
          <b-row>
            <!-- <div v-if="fieldId == value.id">Entrou: {{ fieldId }}</div> -->
            <!-- {{ value }} -->
            <b-col lg="8" md="8" sm="12" v-if="fieldId && fieldId == value.id">
              <!-- {{ fieldId }} -->
              <checklist-filled-details-field-pendency
                ref="checklistFilledDetailsField"
                :checklist-value="value"
                :pendencyFieldId="fieldId"
                @after-attachment-show="verifyShowingEveryAttachments"
              >
              </checklist-filled-details-field-pendency>
            </b-col>
            <b-col lg="12" md="12" sm="12" v-else>
              <checklist-filled-details-field
                ref="checklistFilledDetailsField"
                :checklist-value="value"
                :pendencyFieldId="fieldId"
                @after-attachment-show="verifyShowingEveryAttachments"
              >
              </checklist-filled-details-field>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <!-- <div>{{checklist}}</div> -->
    <!-- <pre class="language-json"><code>{{ checklist  }}</code></pre> -->
  </b-container>
</template>

<script>
import BaseDialogConfirm from "@/components_rms/base/BaseDialogConfirm.vue";
import ChecklistFilledDetailsField from "@/components_rms/checklist/filled/ChecklistFilledDetailsField.vue";
import Vue from "vue";
import VueScrollTo from "vue-scrollto";
Vue.use(VueScrollTo);

export default {
  name: "FilledDetails",
  props: {
    id: String,
    fieldId: Number,
    showBackToList: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    BaseDialogConfirm,
    ChecklistFilledDetailsField,
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    ChecklistFilledMap: () =>
      import("@/components_rms/checklist/map/ChecklistFilledMap.vue"),
    ChecklistHistory: () =>
      import("@/components_rms/checklist/history/ChecklistHistory.vue"),
    ChecklistFilledDetailsFieldPendency: () =>
      import(
        "@/components_rms/checklist/filled/ChecklistFilledDetailsFieldPendency.vue"
      ),
    ChecklistPdfExportParameters: () =>
      import(
        "@/components_rms/checklist/fill/ChecklistPdfExportParameters.vue"
      ),
  },
  directives: {},
  data: function () {
    return {
      alert: {
        error: "",
      },
      checklist: null,
      fullscreenAttachment: "",
      hasAttachments: false,
      isShowingEveryAttachments: false,
      hasPendency: false,
      showAllPendency: false,
      fieldsWithPendency: [],
      fieldPendency: 0,
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "NÃ£o" },
      ],
      parameters: {
        optionMode: 1,
        optionSize: 1,
      },
      companyId: 0,
      showSubCheck: true,
      hasExitFillFilled: true,
    };
  },
  created: function () {
    if (this.id) {
      this.loadData();
      this.hasExitFill();
    }
  },
  computed: {
    formatedDateFill() {
      if (this.checklist) {
        let date = new Date(this.checklist.dateFill);
        return date.toLocaleString();
      }
      return "";
    },
  },
  methods: {
    openHistoryChange() {
      this.$refs.history.openModal();
    },
    hasExitFill() {
      this.$apiVehicle
        .request({
          url: `/vehicle/hasexitfill/${this.id}`,
          method: "GET",
        })
        .then((response) => {
          console.log(response.data);
          this.hasExitFillFilled = response.data;
        });
    },
    exportPdf() {
      this.$apiChecklist
        .request({
          url: `/checklist/exporttopdf/${this.id}`,
          method: "GET",
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    exportPdfV2() {
      this.$apiChecklist
        .request({
          url: `/v2/checklist/exporttopdf/${this.id}/${this.parameters.optionMode}/${this.parameters.optionSize}`,
          method: "GET",
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    reopenChecklist() {
      this.$apiChecklist
        .get(`/checklist/reopen/${this.id}/false`)
        .then((response) => {
          if (response.data.success == true) {
            let checklist = response.data.data;
            this.$router.push(
              `/checklist/Layout/form/Fill/${checklist.formId}/${checklist.id}`
            );
          } else {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);
        });
    },
    reopenChecklistDialog() {
      this.$refs.reopenConfirmDialog.show();
      // this.reopenChecklist();
    },
    openMap() {
      this.$refs.openMap.openModal();
      // this.reopenChecklist();
    },
    hideEveryAttachments() {
      this.$refs.checklistFilledDetailsField.forEach((detailField) => {
        detailField.hideAttachment();
      });
      this.isShowingEveryAttachments = false;
    },
    async loadData() {
      this.$apiChecklist
        .get("/checklist/get/" + this.id.toString() + "/false")
        .then((response) => {
          let checklist = response.data.data;
          this.checklist = checklist;
          this.companyId = checklist.companyId;
          this.hasAttachments =
            this.checklist.values.filter(
              (checklistValue) => checklistValue.hasAttachment
            ).length > 0;
          this.showPendencyFields();
          this.$emit("scroll-page");
        })
        .catch((error) => {
          this.checklist = {};
          this.hasAttachments = false;
          if (error.response && error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    showAllAttachments() {
      this.$refs.checklistFilledDetailsField.forEach((detailField) => {
        detailField.showAttachment();
      });
      this.isShowingEveryAttachments = true;
    },
    verifyShowingEveryAttachments() {
      let total = 0;
      let showing = 0;
      this.$refs.checklistFilledDetailsField.forEach((detailField) => {
        if (detailField.checklistValue.hasAttachment) {
          total++;
          if (detailField.isShowingAttachment) {
            showing++;
          }
        }
      });
      this.isShowingEveryAttachments = total == showing;
    },
    showPendencyFields() {
      this.checklist.values.forEach((value) => {
        if (value.hasOpenPending) this.fieldsWithPendency.push(value);
      });
      if (this.fieldsWithPendency.length != 0) this.hasPendency = true;
    },
    viewAllPendencyFields() {
      this.showAllPendency = true;
    },
    closeAllPendencyFields() {
      this.showAllPendency = false;
    },
    openModal() {
      this.$refs.openModal.show();
    },
  },
};
</script>


